import { render } from "./IconItemCategoryFood.vue?vue&type=template&id=7d5c2485"
import script from "./IconItemCategoryFood.vue?vue&type=script&lang=js"
export * from "./IconItemCategoryFood.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__